import HttpClient from "../helpers/HttpClient"
import AssignmentRule, { AssignmentRuleDto } from "./AssignmentRule"
import { HttpError, isError } from "../helpers/Error"

class AssignmentRuleService {
    httpClient: HttpClient<AssignmentRule, AssignmentRuleDto> = new HttpClient<AssignmentRule, AssignmentRuleDto>(AssignmentRule)

    async RetrieveGlobalAssignmentRules(): Promise<AssignmentRule[] | HttpError> {
        const res = await this.httpClient.get("/assignment-rules")
        if (isError(res)) {
            return res as HttpError
        }
        return (res as AssignmentRule[])
    }

    async UpdateAssignmentRule(
        assignmentKey: string,
        userIds: string[],
        notifyAll: boolean,
    ): Promise<AssignmentRule | HttpError> {
        const payload = {
            userIds: userIds,
            notifyAll: notifyAll,
        }
        const res = await this.httpClient.patch(`/assignment-rules/${assignmentKey}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return (res as AssignmentRule)
    }
}

const instance = new AssignmentRuleService()
export default instance


// WEBPACK FOOTER //
// ./src/state/assignment-rule/AssignmentRuleService.ts